<template>
  <div class="main-content">
    <the-header :title="t(createUser ? 'Create sub-user': 'Edit sub-user')"/>
    <!--        <div class="intro-text">{{t('Some intro text here')}}</div>-->
    <titan-form :schema="schema"
                :newItem="createUser"
                :model="modelData"
                v-on:saveData="saveData()"
                :editable="editable"
    />
  </div>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from 'vue-form-generator';
    import TheHeader from '../../../admin/Layout/TheHeader';

    export default {
        components: {
            TheHeader,
            TitanForm,
        },
        computed: {
            createUser() {
                return this.$route.name === 'subUserCreate';
            },
            editable() {
                return this.hasPermission('NurseTitan', 'U') || this.createUser === true;
            },
        },
        created() {
            this.initData();
        },
        methods: {
            initData() {

                if (this.createUser === false) {
                    this.$store.dispatch('users/get', this.$route.params.id).then(res => {
                        this.modelData = res;
                    });
                } else {
                    let account = this.$store.getters['account/account'];
                    //this.modelData.cellphone =  typeof account === 'object' && account.hasOwnProperty('cellphone') ? account.cellphone : '';
                }
            },
            saveData() {
                const type = this.createUser === true ? 'users/create' : 'users/update';

                let data = {...this.modelData};
                data.role = 'nurse';
                data.parent = this.$store.state.account.user.id;
                if (this.createUser === false) {
                    data.id = this.$route.params.id
                }
                data.subuserType = data.subuserType.id;
                this.$store.dispatch(type, data).then(response => {
                    const message = this.createUser === true ? 'Sub-user was created' : 'Sub-user was updated';
                    data = response;
                    let existingSubUser = this.getUserStore().getByParam('login', data.login);
                    if (existingSubUser === null) {
                        data.securityPin = this.getUserStore().getLoggedUser().get('securityPin');
                        this.getUserStore().add(data);
                    }
                    this.$store.dispatch('alert/success', message);
                    if (this.$route.name !== 'subUserEdit') {
                        this.$router.push({name: 'subUserEdit', params: {id: response.id}});
                    }
                }).catch(error => {
                    this.$store.dispatch('alert/warning', error.data.status);
                });
            }
        },

        data() {
            return {
                loading: true,
                modelData: {},
                schema: [
                    {
                        name: this.t('Sub-user'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-2',
                                label: this.t('Degree'),
                                model: 'titlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-4',
                                label: this.t('Firstname'),
                                model: 'firstname',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-4',
                                label: this.t('Lastname'),
                                model: 'lastname',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-2',
                                label: this.t('Degree'),
                                model: 'titleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: () => {
                                    return this.editable === false;
                                }
                            },
                            {
                                type: 'titanSelect',
                                styleClasses: 'col-4',
                                label: this.t('Profession type'),
                                model: 'subuserType',
                                required: true,
                                values: [
                                    {id: 1, name: this.t('Doctor')},
                                    {id: 2, name: this.t('Nurse')}
                                ],
                                disabled: () => {
                                    return this.editable === false;
                                },
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-4',
                                label: this.t('E-mail'),
                                model: 'login',
                                required: true,
                                validator: VueFormGenerator.validators.email,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                styleClasses: 'col-4',
                                label: this.t('Cellphone'),
                                model: 'cellphone',
                                required: true,
                                hint: this.t('Value must match format "0900123456"'),
                                validator: (value) => {
                                    if (value) {
                                        return null === value.match(/^[0-9]{10}$/) ? [this.t('Please enter phone number in required format')] : []
                                    } else {
                                        return [this.t('Please enter mobile phone number')]
                                    }
                                }
                            },
                            {
                                type: 'password',
                                styleClasses: 'col-6',
                                label: this.t('Password'),
                                model: 'password',
                                required: true,
                                visible: () => this.createUser === true,
                                validator: function (value, field, model) {
                                    if (model.hasOwnProperty('password') && model.password && model.password.length > 0) {
                                        if (model.password.length < 6) {
                                            return [this.t('Password is too short. Please choose a password with at least 6 characters')];
                                        }
                                        if (model.password.length > 40) {
                                            return [this.t('Password is too long. Please choose a password no longer than 40 characters')];
                                        }
                                    } else {
                                        return VueFormGenerator.validators.required(value, field, model);
                                    }
                                }
                            }, {
                                type: 'input',
                                inputType: 'password',
                                styleClasses: 'col-6',
                                label: this.t('Repeat password'),
                                model: 'repeatPassword',
                                required: true,
                                max: 40,
                                min: 6,
                                visible: () => this.createUser === true,
                                validator: function (value, field, model) {
                                    if (model.password !== model.repeatPassword) {
                                        return [this.t('Passwords are not equal')];
                                    }
                                    return VueFormGenerator.validators.required(value, field, model);
                                }
                            }
                        ]
                    }
                ]
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/pages/private/subuser/Manage.vue